import PrimaryButton from "canbook-style/ui/button/primary";
import { ButtonType } from "canbook-style/ui/button/models";
import ErrorPrompt from "canbook-style/ui/prompt/error";
import CountryCodeDropdown from "canbook-style/ui/country-code-dropdown";
import { getCountryByDialCode } from "canbook-data/util/country-codes";
import { PhoneComponentCallback, usePhoneState } from "../hooks";

export function PhoneComponent({
  phoneNumber,
  callback,
  onSwitchToEmail,
}: {
  phoneNumber: string;
  callback: PhoneComponentCallback;
  onSwitchToEmail: () => void;
}) {
  const {
    phoneInputRef,
    errors,
    apiError,
    isInProgress,
    phone,
    setPhone,
    countryCode,
    setCountryCode,
    setApiError,
    handlePhoneSubmit,
    checkPhoneValidation,
    isSubmittedOnce,
  } = usePhoneState(phoneNumber, callback);

  return (
    <div className="px-4 w-full mt-20 lg:mt-0 lg:w-1/2 xl:w-1/3 flex lg:items-center lg:justify-center">
      <div className="w-full sm:w-4/6 lg:w-3/4 mx-auto bg-surface flex flex-col gap-12">
        <h1 className="hidden lg:block d-header-1 text-font-primary">
          Sign up
        </h1>
        <div className="flex flex-col gap-10">
          <div className="w-full">
            <p className="header-2 text-font-primary">
              What’s your phone number?
            </p>
            <p className="body-2 text-font-secondary pt-1">
              A 6 digit OTP will be sent to the phone number for verification.
            </p>
          </div>
          <form
            className="flex flex-col w-full gap-10"
            onSubmit={handlePhoneSubmit}
          >
            <div className="flex flex-col w-full">
              <label className="body-2 text-font-disabled lg:text-font-secondary pl-3 pb-2">
                Phone number
              </label>
              <div className="flex w-full subheader-1 gap-3">
                <CountryCodeDropdown
                  value={countryCode}
                  onChange={setCountryCode}
                />
                <input
                  aria-label="Phone number"
                  type="tel"
                  inputMode="numeric"
                  name="phone"
                  placeholder="Phone number"
                  className="border border-outline bg-container-low py-3 px-4 rounded-xl w-full text-font-primary outline-none focus:border-primary caret-primary"
                  onChange={(e) => {
                    const country = getCountryByDialCode(countryCode);
                    const maxLength = country?.maxLength || 15;
                    const inputVal = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, maxLength);
                    setPhone(inputVal);
                    checkPhoneValidation(inputVal);
                  }}
                  value={phone}
                  autoComplete="off"
                  ref={phoneInputRef}
                />
              </div>
              <div className="mt-1 error-message">
                {isSubmittedOnce &&
                  errors.find(
                    (error) =>
                      error.for == "phone" || error.for == "phone_length",
                  )?.message}
              </div>
            </div>
            <PrimaryButton
              type={ButtonType.submit}
              text="Get OTP"
              isExpanded={true}
              isDisabled={phone == "" || errors.length > 0}
              isInProgress={isInProgress}
            />
          </form>
        </div>
        <div className="flex justify-center pb-6">
          <button
            type="button"
            className="body-2 text-font-secondary underline-offset-4 hover:text-font-primary focus-visible:outline-none"
            onClick={onSwitchToEmail}
          >
            Login with email
          </button>
        </div>
        {apiError && (
          <ErrorPrompt error={apiError} onClose={() => setApiError(null)} />
        )}
      </div>
    </div>
  );
}

export default PhoneComponent;
